import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

import { BrowserRouter } from 'react-router-dom'

import 'tachyons/css/tachyons.min.css'
import './assets/css/index.css'

ReactDOM.render((
	<BrowserRouter>
		<App /> 
	</BrowserRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js